export const getMachineOperationalStatus = (state) => {
  return state.machineOperationalStatus;
};
